<template>
    <v-toolbar dense flat class="mb-4" :color="color || 'white'">
        <v-btn v-if="url" icon @click="$router.push(url)"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <period-select v-if="showPeriod" @update="updatePeriod"/>
    </v-toolbar>
</template>
<script>
import PeriodSelect from './PeriodSelect.vue';
export default {
    components:{PeriodSelect},
    props:['title', 'showPeriod', 'url', 'color'],
    methods:{
        updatePeriod(period){
            this.$emit("period-update", period)
        }
    }
}
</script>